import React, { useEffect } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
    const toggleCaptchaBadge = (show) => {
        const badge = document.getElementsByClassName("grecaptcha-badge")[0];
        if (badge && badge instanceof HTMLElement) {
            badge.style.visibility = show ? "visible" : "hidden";
        }
    };

    useEffect(() => {
        toggleCaptchaBadge(true);
        return () => toggleCaptchaBadge(false);
    }, []);

    return (
        <div className="footer-content">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="footer-links-container">
                            <Navbar
                                collapseOnSelect
                                expand="lg"
                                className="footer-navbar-container"
                            >
                                <div className="copyright-social-container d-none d-md-flex">
                                    <div className="copyright-text">
                                        © {new Date().getFullYear()} Privaposts
                                    </div>
                                    <div className="social-btns">
                                        <a
                                            href="https://www.facebook.com/privaposts"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={["fab", "facebook-f"]}
                                            />
                                        </a>
                                        <a
                                            href="https://www.twitter.com/privaposts"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={["fab", "twitter"]}
                                            />
                                        </a>
                                        <a
                                            href="https://www.instagram.com/privaposts"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={["fab", "instagram"]}
                                            />
                                        </a>
                                        <a
                                            href="https://www.youtube.com/channel/UCvzbIamRLw1okATq4jCAoKw"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={["fab", "youtube"]}
                                            />
                                        </a>
                                    </div>
                                </div>
                                <Navbar.Collapse
                                    id="responsive-navbar-nav"
                                    className="footer-navbar"
                                >
                                    <Nav>
                                        <Nav.Link
                                            href="/"
                                            className="footer-item-link"
                                        >
                                            Home
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/how-it-works"
                                            className="footer-item-link"
                                        >
                                            How It Works
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/referrals"
                                            className="footer-item-link"
                                        >
                                            Referrals
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/terms"
                                            className="footer-item-link"
                                        >
                                            Terms
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/privacy-policy"
                                            className="footer-item-link"
                                        >
                                            Privacy Policy
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/logos"
                                            className="footer-item-link"
                                        >
                                            Logos
                                        </Nav.Link>
                                        <Nav.Link
                                            href="https://priva.uvdesk.com/en/"
                                            className="footer-item-link"
                                        >
                                            Help & FAQs
                                        </Nav.Link>
                                    </Nav>
                                </Navbar.Collapse>
                                <div className="copyright-social-container d-flex d-sm-flex d-md-none">
                                    <div className="copyright-text">
                                        © {new Date().getFullYear()} Privaposts
                                    </div>
                                    <div className="social-btns">
                                        <a
                                            href="https://www.facebook.com/privaposts"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={["fab", "facebook-f"]}
                                            />
                                        </a>
                                        <a
                                            href="https://www.twitter.com/privaposts"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={["fab", "twitter"]}
                                            />
                                        </a>
                                        <a
                                            href="https://www.instagram.com/privaposts"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={["fab", "instagram"]}
                                            />
                                        </a>
                                        <a
                                            href="https://www.youtube.com/channel/UCvzbIamRLw1okATq4jCAoKw"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FontAwesomeIcon
                                                icon={["fab", "youtube"]}
                                            />
                                        </a>
                                    </div>
                                </div>
                                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                            </Navbar>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(Footer);
